export enum CTFiltersEnum {
  EXECUTION_FILTER,
  TAXONOMY_FILTER,
  EXCLUDE_REGIONAL,
}
